/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Sales_Order_Not_Ready_For_SyncInputs */

const en_error_sales_order_not_ready_for_sync = /** @type {(inputs: Error_Sales_Order_Not_Ready_For_SyncInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The order cannot be sent to Business Central yet.`)
};

/**
* | output |
* | --- |
* | "The order cannot be sent to Business Central yet." |
*
* @param {Error_Sales_Order_Not_Ready_For_SyncInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_sales_order_not_ready_for_sync = /** @type {((inputs?: Error_Sales_Order_Not_Ready_For_SyncInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Sales_Order_Not_Ready_For_SyncInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_sales_order_not_ready_for_sync(inputs)
});